import React from 'react';
import { Close } from '@crabs-ai/web-icons';
import { cn, ToolButton } from '@crabs-ai/ds-react';

export type SettingPanelProps = {
  icon: React.ReactNode;
  title: string;
  onClose?: () => void;
  trailingNode?: React.ReactNode;
  hideHeader?: boolean;
  contentScrollable?: boolean;
  contentClassName?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export default function SettingPanel({
  icon,
  title,
  onClose,
  trailingNode,
  hideHeader = false,
  contentScrollable = true,
  contentClassName,
  children,
  className,
  ...props
}: SettingPanelProps) {
  return (
    <div
      className={cn(
        'flex max-h-full min-h-0 flex-col pb-sm',
        !hideHeader && 'pt-2xs',
        className,
      )}
      {...props}
    >
      {!hideHeader && (
        <div className="flex flex-shrink-0 items-center justify-between px-md py-xs">
          <div className="flex items-center gap-4xs text-title-small text-sys-cont-neutral-default [&_path]:fill-sys-cont-neutral-default">
            {icon}
            <span>{title}</span>
          </div>
          <div className="flex items-center gap-4xs">
            {trailingNode}
            {onClose && (
              <ToolButton
                size="sm"
                onClick={onClose}
              >
                <Close className="size-[20px] [&_path]:fill-sys-cont-neutral-default" />
              </ToolButton>
            )}
          </div>
        </div>
      )}
      <div
        className={cn(
          'min-h-0',
          contentScrollable ? 'overflow-y-auto' : 'flex flex-1 overflow-hidden',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
